class Occupation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    if (window.matchMedia("(max-width:1100px)").matches) {
      let cls = 'swiper';

      $(`.${cls}`).each(function(index, el) {
        new Swiper(`.${cls + index}`, {
          slidesPerView: 1.1,
          centeredSlides: true,
          loop: true,
          // Navigation arrows
          navigation: {
            nextEl: `.swiper-button-next${index}`,
            prevEl: `.swiper-button-prev${index}`,
          },
        })
      })
    }


    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0) {
          $(`[href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
          $(`[href="#${$(item).attr('id')}"]`).addClass('is-active')
        } else {
          $(`[href="#${$(item).attr('id')}"]`).removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })
  }
}
